import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { ConsolidatedDataType, FullPeriodontalType } from '@/shared/types'

class PeriodontalReportApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getReports(patientId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/periodontology/report-list',
      params: {
        patient_id: patientId,
      },
    })
  }

  public getReport(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/periodontology/report',
      params: {
        report_id: reportId,
      },
    })
  }

  public saveReport(patientId: number, report: FullPeriodontalType) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/periodontology/create',
      data: {
        date_at: new Date(),
        index: JSON.stringify(report),
        patient_id: patientId,
      },
    })
  }

  public updateReport(reportId: number, report: FullPeriodontalType) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/periodontology/index-update',
      data: {
        report_id: reportId,
        index: JSON.stringify(report),
      },
    })
  }

  public removeReport(reportId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/periodontology/delete/${reportId}`,
    })
  }

  public saveConsolidatedAnalyze(
    reportId: number,
    consolidatedData: ConsolidatedDataType
  ) {
    const { smoking, diabetes } = consolidatedData

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/periodontology/update',
      params: {
        report_id: reportId,
        smoking: Number(smoking),
        diabetes: Number(diabetes),
      },
    })
  }

  public addComment(reportId: number, text: string) {
    const formData = new FormData()
    formData.append('text', text)

    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/periodontology/add-comment/${reportId}`,
      data: formData,
    })
  }

  public removeComment(commentId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/periodontology/delete-comment/${commentId}`,
    })
  }

  public sendEmail(reportId: number, pdf: File) {
    const data = new FormData()
    data.append('report_id', reportId.toString())
    data.append('pdf', pdf)

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/periodontology/send-email',
      data,
    })
  }
}

export const periodontalReportApi = new PeriodontalReportApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
